import { createContext, useCallback, useContext, useState } from "react";
import { scrollToId } from "../lib/scroll";

const LeadContext = createContext(null);

export function LeadProvider({ children }) {
  const [selectedModel, setSelectedModel] = useState("");

  const requestOfferte = useCallback((modelName) => {
    if (modelName) setSelectedModel(modelName);
    scrollToId("offerte");
  }, []);

  return (
    <LeadContext.Provider value={{ selectedModel, setSelectedModel, requestOfferte }}>
      {children}
    </LeadContext.Provider>
  );
}

export function useLead() {
  return useContext(LeadContext);
}
